import { useState } from "react";

const NAV = [
  { label: "持续追踪", href: "#track" },
  { label: "话题墙", href: "#topic" },
  { label: "新瓜速览", href: "#expose" },
  { label: "求证", href: "#verify" },
  { label: "专题合集", href: "#series" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-line/80 bg-paper/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-mark text-cream">
            <i className="ri-radar-fill text-base"></i>
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="font-heading text-lg font-bold tracking-tight">最近黑料</span>
            <span className="hidden text-xs text-faint sm:inline">持续追踪站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap text-sm text-muted transition-colors hover:text-ink"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-mark px-4 py-2 text-sm text-cream transition-colors hover:bg-mark-deep sm:inline-block"
          >
            订阅一手流出
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-line bg-card text-ink md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-line bg-card px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-2 text-sm text-muted transition-colors hover:bg-soft hover:text-ink"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-mark px-4 py-2 text-center text-sm text-cream"
            >
              订阅一手流出
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}